import { appInjector } from '../../app-injector';
import { Util } from '../../core-utilities/Util';
import { UserProfileSettingsService } from '../../system-services/UserProfileSettings';

export type ColumnDefinition = {
    columnId: string;
    headerKey?: string;
    defaultHide: boolean;
};

export class ColumnInfoContainer {
    userProfile: UserProfileSettingsService;
    util: Util;
    tableId: string;

    columns: ColumnDefinition[] = [];
    private columnHash: { [key: string]: ColumnDefinition } = {};

    // takes some
    constructor(tableId: string) {
        this.userProfile = appInjector().get(UserProfileSettingsService);
        this.util = appInjector().get(Util);
        this.tableId = tableId;
    }

    public registerColumn(columnDefinition: ColumnDefinition) {
        if (!this.columnHash[columnDefinition.columnId]) {
            this.columnHash[columnDefinition.columnId] = columnDefinition;
            this.columns.push(columnDefinition);
        }
    }

    public display(columnId: string): boolean {
        const settings = this.userProfile.getTableSettings(this.tableId);
        if (this.util.hasValue(settings[columnId])) {
            return settings[columnId];
        }
        if (this.columnHash[columnId]) {
            return !this.columnHash[columnId].defaultHide;
        }
        return false;
    }
}
